import { render } from "./PrintXrayReport.vue?vue&type=template&id=1ef6df42&scoped=true"
import script from "./PrintXrayReport.vue?vue&type=script&lang=js"
export * from "./PrintXrayReport.vue?vue&type=script&lang=js"

import "./PrintXrayReport.vue?vue&type=style&index=0&id=1ef6df42&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1ef6df42"

export default script